import {
  PACKAGE_LIST_LOADING,
  GET_PACKAGE_LIST_ERROR,
  GET_PACKAGE_LIST,
  GET_PACKAGE_BY_ID_LOADING,
  GET_PACKAGE_BY_ID_SUCCESS,
  GET_PACKAGE_BY_ID_ERROR,
  DELETE_PACKAGE,
  DELETE_PACKAGE_ERROR,
  DELETEING_PACKAGE,
  DELETED_PACKAGE_LIST_LOADING,
  GET_DELETED_PACKAGE_LIST,
  GET_DELETED_PACKAGE_LIST_ERROR,
  RESTORE_PACKAGE_LIST_LOADING,
  RESTORE_PACKAGE_LIST,
  RESTORE_PACKAGE_LIST_ERROR,
  PERMA_DELETE_PACKAGE,
  PERMA_DELETE_PACKAGE_ERROR,
  PERMA_DELETEING_PACKAGE,  
  SORTING_PACKAGE,
  SORT_PACKAGE,
  PACKAGE_SORT_ERROR,
} from "./types";

const INITIAL_STATE = {
  data: undefined,
  loading: false,
  error: false,
  dataById: undefined,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PACKAGE_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_PACKAGE_BY_ID_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETED_PACKAGE_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETEING_PACKAGE:
      return {
        ...state,
        loading: true,
        error: false,
      };

      case SORTING_PACKAGE:
        return {
          ...state,
          loading: true,
          error: false,
        };

    case RESTORE_PACKAGE_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case PERMA_DELETEING_PACKAGE:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case GET_PACKAGE_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case GET_PACKAGE_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        dataById: action.payload.data,
        error: false,
      };

    case DELETE_PACKAGE:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case GET_DELETED_PACKAGE_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case RESTORE_PACKAGE_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case PERMA_DELETE_PACKAGE:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
      case SORT_PACKAGE:
        return {
          ...state,
          loading: false,
          data: action.payload.data,
          error: false,
        };
    case GET_PACKAGE_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_PACKAGE_BY_ID_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_DELETED_PACKAGE_LIST_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case DELETE_PACKAGE_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case RESTORE_PACKAGE_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case PERMA_DELETE_PACKAGE_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };

      case PACKAGE_SORT_ERROR:
        return {
          ...state,
          data: undefined,
          loading: false,
          error: action.payload.data,
        };

    default:
      return state;
  }
};

export default reducer;
